import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  private hiddenClass = "d-none";
  private visibleClass = "d-xl-grid";

  static targets = ["button", "content"];
  static values = {
    buttonCollapsed: String,
    buttonExpanded: String,
    open: Boolean,
  };

  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly contentTargets: HTMLElement[];
  declare buttonCollapsedValue: string;
  declare buttonExpandedValue: string;
  declare openValue: boolean;

  toggle() {
    this.openValue = !this.openValue;
    this.toggleItems();
    this.updateButtonText();
    this.updateButtonAria();
    this.buttonTarget.blur();
    if (!this.openValue) {
      this.scrollToButtonTarget();
    }
  }

  toggleItems() {
    this.contentTargets.forEach((item) => {
      if (this.openValue && item.classList.contains(this.hiddenClass)) {
        item.classList.remove(this.hiddenClass);
      } else if (
        !this.openValue &&
        item.classList.contains(this.visibleClass)
      ) {
        item.classList.add(this.hiddenClass);
      }
    });
  }

  updateButtonText() {
    this.buttonTarget.textContent = this.openValue
      ? this.buttonExpandedValue
      : this.buttonCollapsedValue;
  }

  updateButtonAria() {
    this.buttonTarget.setAttribute("aria-expanded", `${this.openValue}`);
  }

  scrollToButtonTarget() {
    this.buttonTarget.scrollIntoView({
      block: "end",
    });
  }
}
